<template>
  <transition name="fade">
    <div class="modal show" style="display: block;">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <span></span>
            Email your Developer
            <div class="btn-close-wrapper" @click.stop="closeModal">
              <span class="material-icons">close</span>
            </div>
          </div>
          <div class="modal-body">
            <form @submit.prevent>
              <div class="form-group">
                <label>Email</label>
                <input type="email" v-model.trim="email" class="form-control" placeholder="Email" required />
              </div>
            </form>
          </div>
          <div class="modal-footer">
            <span></span>
            <button type="button" class="xpl-button xpl-button--primary" :disabled="!email" @click.stop="emailDeveloper">Send</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import EventBus from '@/event-bus';
  import * as api from '@/api';

  export default {
    props: ['code'],
    data() {
      return {
        email: '',
      };
    },
    methods: {
      closeModal() {
        EventBus.$emit('email_dev.close');
      },
      emailDeveloper(event) {
        if (!this.email) {
          return;
        }

        const target = event.target || event.srcElement;
        target.disabled = true;

        const payload = {
          code: this.code,
          email: this.email.toLowerCase(),
        };

        api.formEmailDeveloper(payload).then((response) => {
          this.$toasted.success(response.message);
          this.closeModal();
        }).catch((err) => {
          target.disabled = false;
          if (Object.prototype.hasOwnProperty.call(err, 'errors') && Object.keys(err.errors).length) {
            this.$toasted.error(err.errors[Object.keys(err.errors)[0]]);
          } else {
            this.$toasted.error(err.message);
          }
        });
      },
    },
  };
</script>
